import { render, staticRenderFns } from "./FormActionButtons.vue?vue&type=template&id=f38d166c&scoped=true&"
import script from "./FormActionButtons.vue?vue&type=script&lang=js&"
export * from "./FormActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./FormActionButtons.vue?vue&type=style&index=0&id=f38d166c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38d166c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
